import React from 'react';

import ContentfulImage from '../../Common/ContentfulImage';
import { ArrowLink } from '../../Common/Links';
import * as styles from './OptionalCard.module.scss';

const OptionalCard = ({ optionalCard = null }) => {
  return (
    <div className={styles.optionalCard} data-analytics-component={'header-nav-optional-card'}>
      <div className={styles.copy}>
        {optionalCard.title}
        <ArrowLink url={optionalCard.linkUrl} isExternal hoverAnimation label={optionalCard.linkLabel} />
      </div>
      <ContentfulImage className={styles.image} objectFit={'contain'} imageFragment={optionalCard.image} />
    </div>
  );
};

export default OptionalCard;
